import { ConnectionLength } from './ConnectionLength.js';
import { GoogleGeometry } from './GoogleGeometry.js';

function GetConnectionLookup(nodes, connections, useMetricUnits) {
  return GetExtendedConnectionLookup({
    nodes,
    connections,
    useMetricUnits
  }).lookupByNode;
}

function GetExtendedConnectionLookup(options) {
  options = options || {};
  // Default to false for using metric units
  options.useMetricUnits = options.useMetricUnits || false;
  let res = {
    lookupByNode: {},
    lookupByPhoto: {}
  };
  let nodes = options.nodes;
  let connections = options.connections;
  for (var connId in connections) {
    //Get Connection Main Photo
    var mainPhotoId = null;
    var mainPhotoSectionId = null;
    let sectionKeys = [];
    if (connections[connId].sections != null) {
      sectionKeys = Object.keys(connections[connId].sections);
      if (connections[connId].sections.midpoint_section != null) {
        for (var photoId in connections[connId].sections.midpoint_section.photos) {
          if (
            connections[connId].sections.midpoint_section.photos[photoId] == 'main' ||
            connections[connId].sections.midpoint_section.photos[photoId].association == 'main'
          ) {
            mainPhotoId = photoId;
            mainPhotoSectionId = 'midpoint_section';
            break;
          }
        }
      } else {
        for (var sectionId in connections[connId].sections) {
          for (let photoId in connections[connId].sections[sectionId].photos) {
            if (
              connections[connId].sections[sectionId].photos[photoId] == 'main' ||
              connections[connId].sections[sectionId].photos[photoId].association == 'main'
            ) {
              mainPhotoId = photoId;
              mainPhotoSectionId = sectionId;
            }
          }
          if (mainPhotoId != null) {
            break;
          }
        }
      }
    }

    //Get Conn Type
    var conn_type = null;
    if (connections[connId].attributes && connections[connId].attributes.connection_type) {
      let firstKey = Object.keys(connections[connId].attributes.connection_type);
      conn_type = connections[connId].attributes.connection_type[firstKey];
    }
    let n1Id = connections[connId].node_id_1;
    let n2Id = connections[connId].node_id_2;
    if (nodes[n1Id] && nodes[n2Id]) {
      let n1LL = new GoogleGeometry.maps.LatLng(nodes[n1Id].latitude, nodes[n1Id].longitude);
      let n2LL = new GoogleGeometry.maps.LatLng(nodes[n2Id].latitude, nodes[n2Id].longitude);
      let length = ConnectionLength(connections[connId], nodes, options.useMetricUnits);
      let bearing1 = (GoogleGeometry.maps.geometry.spherical.computeHeading(n1LL, n2LL) + 360) % 360;
      let bearing2 = (GoogleGeometry.maps.geometry.spherical.computeHeading(n2LL, n1LL) + 360) % 360;

      var conn_type = null;
      if (connections[connId].attributes && connections[connId].attributes.connection_type) {
        let firstKey = Object.keys(connections[connId].attributes.connection_type);
        conn_type = connections[connId].attributes.connection_type[firstKey];
      }

      let toScid1 = null;
      if (nodes && nodes[n1Id] && nodes[n1Id].attributes && nodes[n1Id].attributes.scid) {
        let firstKey = Object.keys(nodes[n1Id].attributes.scid);
        toScid1 = nodes[n1Id].attributes.scid[firstKey];
      }
      let toScid2 = null;
      if (nodes && nodes[n2Id] && nodes[n2Id].attributes && nodes[n2Id].attributes.scid) {
        let firstKey = Object.keys(nodes[n2Id].attributes.scid);
        toScid2 = nodes[n2Id].attributes.scid[firstKey];
      }

      //Set lookup for node_id_1
      res.lookupByNode[n1Id] = res.lookupByNode[n1Id] || [];
      res.lookupByNode[n1Id].push({
        connId: connId,
        mainPhotoId: mainPhotoId,
        mainPhotoSectionId,
        sectionKeys,
        fromNodeId: n1Id,
        toNodeId: n2Id,
        fromNode: nodes[n1Id],
        toNode: nodes[n2Id],
        conn_type: conn_type,
        bearing: bearing1,
        length,
        fromScid: toScid1,
        toScid: toScid2,
        connData: JSON.parse(JSON.stringify(connections[connId]))
      });

      //Set lookup for node_id_2
      res.lookupByNode[n2Id] = res.lookupByNode[n2Id] || [];
      res.lookupByNode[n2Id].push({
        connId: connId,
        mainPhotoId: mainPhotoId,
        mainPhotoSectionId,
        sectionKeys,
        fromNodeId: n2Id,
        toNodeId: n1Id,
        fromNode: nodes[n2Id],
        toNode: nodes[n1Id],
        conn_type: conn_type,
        bearing: bearing2,
        length,
        fromScid: toScid2,
        toScid: toScid1,
        connData: JSON.parse(JSON.stringify(connections[connId]))
      });

      // Set lookup for photo_id.
      res.lookupByPhoto[mainPhotoId] = res.lookupByPhoto[mainPhotoId] || [];
      res.lookupByPhoto[mainPhotoId].push({
        connId: connId,
        mainPhotoId: mainPhotoId,
        mainPhotoSectionId,
        sectionKeys,
        conn_type: conn_type,
        length,
        connData: JSON.parse(JSON.stringify(connections[connId]))
      });
    }
  }
  return res;
}

export { GetConnectionLookup, GetExtendedConnectionLookup };
